<template>
  <div class="d-flex event-status" :class="size">
    <div class="d-flex position-static checkin-value">
      <div
        class="align-self-center mr-2 kr-status variant"
        :data-variant="VARIANT_MAP['status-' + checkin.newStatus]"
        data-apply-bg-color
      >
        {{ krStatusText(checkin.newStatus) }}
      </div>
      <div class="kr-value bold" v-if="kr.measureBy === KR_MEASURING_UNIT.BOOLEAN">
        {{ krMeasurementText(kr.measureBy, checkin.newCurrent) }}
      </div>
      <div class="kr-value text-nowrap" v-else>
        <span class="kr-current-value bold">
          {{ krMeasurementText(kr.measureBy, checkin.newCurrent) }}</span
        >
        <span class="text-secondary"> / {{ krMeasurementText(kr.measureBy, kr.end) }}</span>
      </div>
    </div>
    <div
      class="col-3 pl-2 position-static percent-change"
      v-if="kr.measureBy !== KR_MEASURING_UNIT.BOOLEAN"
    >
      <div
        class="d-flex align-items-center"
        :class="getCheckinEventImpact(checkin, kr) === 'INCREASING' ? 'green' : 'red'"
        v-if="getChangedPercent() !== 0"
      >
        <i
          :class="getCheckinEventImpact(checkin, kr) === 'INCREASING' ? 'arrow-up' : 'arrow-down'"
        ></i>
        {{ getChangedPercent() }}%
      </div>
    </div>
  </div>
</template>

<script>
import { VARIANT_MAP } from '@/constants/common'
import { KR_MEASURING_UNIT } from '@/constants/kr'
import { krMeasurementText, formatHyphenatedString } from '@/goalUtils'
import getCheckinEventImpact from '@/utils/getCheckinEventImpact'

/**
 * This component gives view for checkin values (status, value, changed percent)
 */
export default {
  name: 'CheckinValues',
  props: {
    checkin: {},
    kr: {},
    /**
     * This controls the font-sizes of the components
     */
    size: { default: 'md' }
  },
  data() {
    return {
      KR_MEASURING_UNIT,
      VARIANT_MAP
    }
  },
  methods: {
    getChangedPercent() {
      let percent =
        ((this.checkin.newCurrent - this.checkin.oldCurrent) * 100) / (this.kr.end - this.kr.start)
      return Math.round(Math.abs(percent))
    },
    krStatusText: formatHyphenatedString,
    getCheckinEventImpact,
    krMeasurementText
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_goals.scss';
@import '~@/styles/_styleConfigurations.scss';

.event-status {
  padding: 4px 0 12px 0;
}
.kr-status {
  border-radius: 20px;
}
.arrow-up {
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid $active;
  margin-right: 4px;
}

.arrow-down {
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid $error;
  margin-right: 4px;
}
.green {
  color: $active;
}

.red {
  color: $error;
}
.sm {
  .kr-status {
    font-size: 0.6875rem;
  }
  .kr-value,
  .percent-change {
    font-size: 0.8125rem;
  }
}
</style>
